import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inmobiliaria/subProyectos';
import SubProyectos from './subProyectosList';


const ms2p = (state) => {
  return {
    ...state.subProyectos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SubProyectos);
